import { ExperienceTemplateRenderer, TemplateComponent, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { UitkSpacing } from 'uitk-react-spacing';

export interface ToolbarRegionProps extends TemplateComponentProps {
  templateComponent: TemplateComponent;
}

export const ToolbarRegion: React.FC<ToolbarRegionProps> = ({ templateComponent }) => {
  const { children } = templateComponent;

  if (!children || children.length === 0) {
    return null;
  }

  return (
    <ErrorBoundary label="hotel.masterPage.toolbar">
      <UitkSpacing margin={{ medium: { blockstart: 'two' }, large: { blockstart: 'three' } }}>
        <section className="toolbar-region">{children && <ExperienceTemplateRenderer templateComponents={children} />}</section>
      </UitkSpacing>
    </ErrorBoundary>
  );
};
